export const COLOR_GREY_1 = '#D9D9D9';
